(function ($) {
  'use strict';

  if (!$) return;

  var $body = $(document.body);
  var pendingChange = null;
  var inventoryRequestId = 0;

  function rootUrl() {
    if (
      window.Shopify &&
      Shopify.routes &&
      Shopify.routes.root
    ) {
      return Shopify.routes.root;
    }

    if (
      window.theme &&
      theme.routes &&
      theme.routes.rootUrlSlash
    ) {
      return theme.routes.rootUrlSlash;
    }

    return '/';
  }

  function getCartRow(line) {
    return $(
      '#CartContainer .ajaxcart__row[data-line="' +
        line +
        '"]'
    );
  }

  function getCartRowByGroup(groupId) {
    if (!groupId) return $();

    return $(
      '#CartContainer .ajaxcart__row[data-cart-group="' +
        groupId +
        '"]'
    );
  }

  function getRowKey($row) {
    if (!$row || !$row.length) {
      return '';
    }

    return String(
      $row
        .find('.ajaxcart__qty--plus')
        .attr('data-id') ||
      $row
        .find('.ajaxcart__qty-num')
        .attr('data-id') ||
      ''
    );
  }

  function getRowByKey(key) {
    if (!key) return $();

    return $(
      '#CartContainer .ajaxcart__row'
    ).filter(function () {
      return (
        getRowKey($(this)) ===
        String(key)
      );
    });
  }

  function getRowQty($row) {
    if (!$row || !$row.length) {
      return 0;
    }

    var qty = parseInt(
      $row
        .find('.ajaxcart__qty-num')
        .val(),
      10
    );

    return isNaN(qty) ? 0 : qty;
  }

  function setRowLimited(
    $row,
    limited
  ) {
    if (!$row || !$row.length) {
      return;
    }

    var $plus =
      $row.find(
        '.ajaxcart__qty--plus'
      );

    var $notice =
      $row.find(
        '[data-ajaxcart-stock-notice]'
      );

    $plus
      .prop(
        'disabled',
        limited
      )
      .toggleClass(
        'is-stock-limit',
        limited
      );

    if (limited) {
      $plus.attr(
        'aria-disabled',
        'true'
      );

      $notice
        .prop('hidden', false)
        .removeAttr('hidden');
    } else {
      $plus.removeAttr(
        'aria-disabled'
      );

      $notice
        .prop('hidden', true)
        .attr(
          'hidden',
          'hidden'
        );
    }
  }

  function clearStates() {
    $(
      '#CartContainer .ajaxcart__row'
    ).each(function () {
      setRowLimited(
        $(this),
        false
      );
    });
  }

  function parseInventory(html) {
    var parser =
      new DOMParser();

    var doc =
      parser.parseFromString(
        html,
        'text/html'
      );

    var node =
      doc.querySelector(
        '[data-cart-inventory-json]'
      );

    if (!node) return null;

    try {
      return JSON.parse(
        node.textContent
      );
    } catch (error) {
      return null;
    }
  }

  function applyInventory(data) {
    clearStates();

    if (
      !data ||
      !Array.isArray(data.items)
    ) {
      return;
    }

    var variants = {};
    var keyToVariant = {};

    data.items.forEach(
      function (item) {
        var variantId =
          String(
            item.variant_id
          );

        var key =
          String(item.key);

        keyToVariant[key] =
          variantId;

        if (
          !variants[variantId]
        ) {
          variants[variantId] = {
            quantity: 0,

            inventory:
              Number(
                item.inventory_quantity
              ),

            management:
              item.inventory_management,

            policy:
              item.inventory_policy
          };
        }

        variants[
          variantId
        ].quantity +=
          Number(
            item.quantity
          ) || 0;
      }
    );

    $(
      '#CartContainer .ajaxcart__row'
    ).each(function () {
      var $row =
        $(this);

      var key =
        getRowKey($row);

      var variantId =
        keyToVariant[key];

      if (
        !variantId ||
        !variants[variantId]
      ) {
        return;
      }

      var variant =
        variants[variantId];

      if (
        !variant.management ||
        variant.policy ===
          'continue'
      ) {
        return;
      }

      if (
        !isFinite(
          variant.inventory
        )
      ) {
        return;
      }

      setRowLimited(
        $row,
        variant.quantity >=
          variant.inventory
      );
    });
  }

  function refreshInventory() {
    var requestId =
      ++inventoryRequestId;

    fetch(
      rootUrl() +
        '?section_id=cart-inventory-data&_=' +
        Date.now(),
      {
        credentials:
          'same-origin',

        cache:
          'no-store'
      }
    )
      .then(function (
        response
      ) {
        if (!response.ok) {
          throw new Error(
            'Inventory request failed'
          );
        }

        return response.text();
      })
      .then(function (html) {
        if (
          requestId !==
          inventoryRequestId
        ) {
          return;
        }

        var data =
          parseInventory(html);

        if (data) {
          applyInventory(data);
        }
      })
      .catch(function () {});
  }

  function parseError(xhr) {
    if (
      !xhr ||
      !xhr.responseText
    ) {
      return null;
    }

    try {
      return JSON.parse(
        xhr.responseText
      );
    } catch (error) {
      return null;
    }
  }

  $body.on(
    'beforeChangeItem.ajaxCart.stockLimit',
    function (
      event,
      line,
      quantity,
      meta
    ) {
      var $row =
        meta &&
        meta.groupId
          ? getCartRowByGroup(
              meta.groupId
            )
          : getCartRow(line);

      var oldQty =
        meta &&
        typeof meta.groupOldQty !==
          'undefined'
          ? parseInt(
              meta.groupOldQty,
              10
            )
          : getRowQty($row);

      var requestedQty =
        meta &&
        typeof meta.groupRequestedQty !==
          'undefined'
          ? parseInt(
              meta.groupRequestedQty,
              10
            )
          : parseInt(
              quantity,
              10
            );

      pendingChange = {
        key:
          getRowKey($row),

        groupId:
          meta &&
          meta.groupId
            ? meta.groupId
            : '',

        oldQty:
          isNaN(oldQty)
            ? getRowQty($row)
            : oldQty,

        requestedQty:
          isNaN(requestedQty)
            ? getRowQty($row)
            : requestedQty
      };
    }
  );

  $body.on(
    'afterChangeItem.ajaxCart.stockLimit',
    function () {
      pendingChange = null;
    }
  );

  $body.on(
    'errorChangeItem.ajaxCart.stockLimit',
    function (
      event,
      xhr,
      textStatus,
      meta
    ) {
      var data =
        parseError(xhr);

      if (
        data &&
        Number(
          data.status
        ) === 422 &&
        pendingChange &&
        pendingChange.key &&
        pendingChange
          .requestedQty >
          pendingChange
            .oldQty
      ) {
        setRowLimited(
          pendingChange.groupId
            ? getCartRowByGroup(
                pendingChange.groupId
              )
            : getRowByKey(
                pendingChange.key
              ),
          true
        );
      }

      pendingChange = null;
    }
  );

  $body.on(
    'afterCartLoad.ajaxCart.stockLimit',
    function () {
      refreshInventory();
    }
  );

})(window.jQuery);